// Optimistic vote math (QAL-T5). Mirrors the server's toggle semantics
// (T5 contract §1) so the pill can update INSTANTLY; the server response
// overwrites this afterwards and is always the truth:
//   * click the vote you already have  → vote removed  (my_vote → null)
//   * click the other vote             → vote switched (±2 on the net)
//   * no vote yet                      → vote created  (±1)
// The DISPLAYED score is capped at 0 like the server caps it — the local
// number can differ from the server's when hidden negative net is involved
// (displayed 0, net -2, upvote → locally 1, server says 0). That is fine
// by design: optimistic first, server overwrite second.
export const applyVote = (score, myVote, value) => {
  const base = Number.isFinite(score) ? score : 0;
  const current = myVote === 1 || myVote === -1 ? myVote : null;
  if (current === value) {
    // Toggle off — take the own vote back out.
    return { score: Math.max(0, base - value), my_vote: null };
  }
  const delta = current === null ? value : 2 * value;
  return { score: Math.max(0, base + delta), my_vote: value };
};

export default applyVote;
